const cookieDomains = ['localhost', '.postpone.app']

export function isCookieSet(name) {
  const cookies = document.cookie.split(';').map((c) => c.trim())
  return cookies.some((c) => c.startsWith(name + '='))
}

export function setCookie(name, value, days = 365) {
  let d = new Date()
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000)
  const expires = 'expires=' + d.toUTCString()
  for (let domain of cookieDomains) {
    document.cookie = `${name}=${value};${expires};domain=${domain};path=/`
  }
}
